import type { OrderListResultData } from '@frontend/api';

export const getRowLinkDestination = (rowData: OrderListResultData): string =>
  `/orders/edit/${rowData.number}`;
